require('./aggregatorConsentsSignaturePattern.scss');
// @ vendors
const React = require("react");

// @ components
const SignaturePattern =
    require("components/signaturePattern/signaturePattern").SignaturePattern;

class AggregatorConsentsSignaturePattern extends React.Component {
    render() {
        return (
            <div className="signature-pattern-aggregator-consents">
                <SignaturePattern
                    printTitleValue={""}
                    operationType={'244'}
                    operationParams={{}}
                />
            </div>
        );
    }
}

export { AggregatorConsentsSignaturePattern };